<template>
  <div>
    <h3 class="text-size-lg-md weight--heavier layout--margin-bottom-md">
      2. Choose Billing Period
    </h3>
    <form class="account__form-section account__form-section--wide">
      <p>You've selected the <strong>{{ subscriptionData.label }} Plan</strong></p>
      <input
        type="radio"
        id="monthly"
        name="monthly"
        value="0"
        class="modal-window__option-radio"
        v-model="selectedOption"
      />
      <label for="monthly">
        <div
          class="modal-window__option modal-window__option--narrow"
          v-bind:class="{
            'modal-window__option--active': selectedOption === '0',
          }"
        >
          <div class="layout--flex-start">
            <IconCheckboxChecked
              v-if="selectedOption === '0'"
              class="icon icon--medium layout--margin-right-xs"
            />
            <IconCheckboxUnchecked
              v-if="selectedOption === '1'"
              class="icon icon--medium layout--margin-right-xs"
            />
            <p class="modal-window__option-title">Billed Monthly</p>
          </div>
          <div class="layout--flex-start layout--flex-align-end">
            <p class="text-size-lg-md">
              {{ subscriptionData.monthlyPriceLabel }}
            </p>
            <div class="text-size-default">/month</div>
          </div>
        </div>
      </label>
      <input
        type="radio"
        id="annually"
        name="annually"
        value="1"
        class="modal-window__option-radio"
        v-model="selectedOption"
      />
      <label for="annually">
        <div
          class="modal-window__option modal-window__option--narrow "
          v-bind:class="{
            'modal-window__option--active': selectedOption === '1',
          }"
        >
          <div class="layout--flex-start">
            <div>
              <IconCheckboxChecked
                v-if="selectedOption === '1'"
                class="icon icon--medium layout--margin-right-xs"
              />
              <IconCheckboxUnchecked
                v-if="selectedOption === '0'"
                class="icon icon--medium layout--margin-right-xs"
              />
            </div>
            <div>
              <p
                class="modal-window__option-title weight--light layout--margin-bottom-none layout--margin-top-none"
              >
                Billed Annually <i class="text-color--blue">(Save 20%)</i>
              </p>
              <p class="weight--light layout--margin-top-xs">
                Save ${{ annualSavings }}/year with annual billing
              </p>
            </div>
          </div>
          <div class="layout--flex-start layout--flex-align-end">
            <p class="text-size-lg-md">
              {{ subscriptionData.annualPriceLabel }}
            </p>
            <div class="text-size-default">/year</div>
          </div>
        </div>
      </label>
      <router-link
        :to="{
          name: 'summary',
          params: { subscriptionType, billingPeriod: selectedOption },
        }"
        type="button"
        class="button button--big layout--margin-bottom-xs layout--margin-top-lg layout--center layout--inline-block"
        >Continue</router-link
      >
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import IconCheckboxChecked from "../../../assets/icons/checkbox-Checked.svg";
import IconCheckboxUnchecked from "../../../assets/icons/checkbox-Unchecked.svg";

export default {
  name: "chooseBillingPeriod",
  components: {
    IconCheckboxChecked,
    IconCheckboxUnchecked,
  },
  mounted: function() {
    if (this.sortedSubscriptionOptions.length === 0) {
      this.getSubscriptionOptions();
    }
  },
  data() {
    return { selectedOption: "0" };
  },
  methods: {
    ...mapActions("account", ["getSubscriptionOptions"]),
  },
  computed: {
    ...mapGetters("account", [
      "sortedSubscriptionOptions",
      "subscription",
      "subscriptionOption",
    ]),
    subscriptionType: function() {
      return parseInt(this.$route.params.subscriptionType);
    },
    subscriptionData: function() {
      if (
        this.sortedSubscriptionOptions.length > 0 &&
        this.$route.params.subscriptionType
      ) {
        return this.sortedSubscriptionOptions.find(
          s => s.subscriptionType === this.subscriptionType
        );
      }
      return { monthlyPriceLabel: "" };
    },
    annualSavings: function() {
      return (
        this.subscriptionData.monthlyPrice * 12 -
        this.subscriptionData.annualMonthlyPrice * 12
      );
    },
  },
};
</script>

<style></style>
